import React, { useState, useEffect } from 'react';
import { RiSearchLine } from 'react-icons/ri';
import { Input } from 'reactstrap';

const DebounceTextInput = ({
  onInputChange,
  delay,
  value: initialValue,
  classWrapper = '',
  placeholder = 'Search',
  positionTop = '0',
  positionRight = '60px',
  callBackBlur,
  callBackFocus,
}) => {
  const [inputValue, setInputValue] = useState(initialValue);
  const [inputSize, setInputSize] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onInputChange(inputValue);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, onInputChange, delay]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleFocus = () => {
    setInputSize('increase-size');
    if (callBackFocus) {
      callBackFocus(inputValue);
    }
  };

  const handleBlur = () => {
    setInputSize(inputValue.length ? 'increase-size' : '');
    if (callBackBlur) {
      callBackBlur(inputValue);
    }
  };

  return (
    <div
      style={{ marginTop: positionTop, right: positionRight }}
      className={`searchbar ${inputSize} bg-white d-inline-block ${classWrapper}`}
    >
      <Input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        bsSize="sm"
        onFocus={handleFocus}
        onBlur={handleBlur}
        className="bg-transparent"
        placeholder={placeholder}
      />
      <RiSearchLine size={16} color="#978E87" />
    </div>
  );
};

export default DebounceTextInput;
